import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"

@Injectable({
  providedIn: 'root'
})
export class IataCommissionService {
  constructor(private http : HttpClient) {}

  UploadIataCommissions(request:any){
      
    let headers = new HttpHeaders();
    const formData = new FormData();
    formData.append("file", request)
    return this.http.post(environment.API_URL+"/api/common/commission/bulk",formData,{headers : headers,observe:"response"});
 
    }
    UpdateIataCommissions(request:any){
      
      let headers = new HttpHeaders();
      return this.http.post(environment.API_URL+"/api/common/commission/update",request,{headers : headers,observe:"response"});
   
      }
}
